import React from 'react'
import { Link } from "react-router-dom";

import "./Navbar.css";


function Navbar() {


  return (
    <div>
      <div className='fixed-top'>
        <div className='asthadigital'>
          <div className="album py-1">
            <div className="container">
              <div className="row ">

                <div className="col-md-6">

                  <div className="d-flex justify-content-between align-items-center">
             <a style={{color:"#ffffff"}} className='' href='mailto:  care@asthadigitalservices.com'><small> care@asthadigitalservices.com</small>
</a>

                    <a style={{ color: "white" }} href='print_teacher_applicationfrom'>Print Application</a>
                  </div>
                </div>
              </div>
            </div>
          </div>

        </div>

        <nav className="navbar navbar-expand-lg navbar-white bg-white shadaw">
          <div className="container-fluid">
            <a href='/' >
              <b style={{ color: "#142C74" }}>Astha Digital Services</b>
            </a>
            <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
              <span className="navbar-toggler-icon"></span>
            </button>
            <div className="collapse navbar-collapse" id="navbarSupportedContent">
              <ul className="navbar-nav mx-auto mb-2 mb-lg-0">
                <li className="nav-item">

                  <a className="nav-link active" aria-current="page" href="/"><b className='home'>Home</b></a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="about"> <b className='home'>About us</b></a>
                </li>
                <li className="nav-item">
                  <a className="nav-link" href="course"> <b className='home'>Courses</b></a>
                </li>

                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'>Admission</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="StudentFrom" >Student Application</a></li>
                    <li><a className="dropdown-item" href="TeacherForm" >Teacher Application</a></li>





                  </ul>
                </li>




                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'>Activities</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="#">Video</a></li>
                    <li><a className="dropdown-item" href="#">Photo</a></li>




                  </ul>
                </li>


                <li className="nav-item dropdown">
                  <a className="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                    <b className='home'>Contact us</b>
                  </a>
                  <ul className="dropdown-menu" aria-labelledby="navbarDropdown">
                    <li><a className="dropdown-item" href="Contact-us">Contact us </a></li>
                    <li><a className="dropdown-item" href="#">News Media </a></li>

                  </ul>
                </li>

              </ul>
              {/* <a href='tel: 08001110006'>
        <button className="helpline" type="submit"><svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" fill="currentColor" class="bi bi-telephone-forward-fill" viewBox="0 0 16 16">
  <path fill-rule="evenodd" d="M1.885.511a1.745 1.745 0 0 1 2.61.163L6.29 2.98c.329.423.445.974.315 1.494l-.547 2.19a.68.68 0 0 0 .178.643l2.457 2.457a.68.68 0 0 0 .644.178l2.189-.547a1.75 1.75 0 0 1 1.494.315l2.306 1.794c.829.645.905 1.87.163 2.611l-1.034 1.034c-.74.74-1.846 1.065-2.877.702a18.6 18.6 0 0 1-7.01-4.42 18.6 18.6 0 0 1-4.42-7.009c-.362-1.03-.037-2.137.703-2.877zm10.761.135a.5.5 0 0 1 .708 0l2.5 2.5a.5.5 0 0 1 0 .708l-2.5 2.5a.5.5 0 0 1-.708-.708L14.293 4H9.5a.5.5 0 0 1 0-1h4.793l-1.647-1.646a.5.5 0 0 1 0-.708"/>
</svg> Help Line Number</button>
        </a> */}

            </div>
          </div>
        </nav>
      </div>
    </div>
  )
}

export default Navbar